const ProductDetailAddCart = {
  options: {
    data: {
      priceText: {
        type: 'Text',
        order: 1,
      },
      buttonText: {
        type: 'Text',
        order: 6,
      },
    },
    customization: {
      backgroundColor: {
        type: 'HexColor',
        order: 1,
      },
      priceTextColor: {
        type: 'HexColor',
        order: 2,
      },
      priceTextSize: {
        type: 'RangePx',
        data: {
          max: 15,
          min: 0,
          step: 1,
        },
        order: 3,
      },
      priceTextWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 4,
      },
      sellPriceNumberTextSize: {
        type: 'RangePx',
        data: {
          max: 15,
          min: 0,
          step: 1,
        },
        order: 5,
      },
      sellPriceNumberTextColor: {
        type: 'HexColor',
        order: 6,
      },
      sellPriceNumberTextWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 7,
      },
      discountPriceNumberTextSize: {
        type: 'RangePx',
        data: {
          max: 15,
          min: 0,
          step: 1,
        },
        order: 8,
      },
      discountPriceNumberTextColor: {
        type: 'HexColor',
        order: 9,
      },
      discountPriceNumberTextWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 10,
      },
      buttonTextColor: {
        type: 'HexColor',
        order: 11,
      },
      buttonTextSize: {
        type: 'RangePx',
        data: {
          max: 15,
          min: 0,
          step: 1,
        },
        order: 12,
      },
      buttonTextWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 13,
      },
      buttonBackgroundColor: {
        type: 'HexColor',
        order: 14,
      },
    },
    widgets: {
      Menu_DiscountSettings: {
        order: 15,
        type: 'Menu',
        renderOptions: {
          controlKey: 'discountSettings',
        },
        options: {
          'widget.Tabs_1': {
            type: 'Tabs',
            order: 8,
            options: {
              discountBoxPadding: {
                data: {
                  max: 20,
                  min: 0,
                  step: 2,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              discountBoxBorderRadius: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
          discountBoxBackgroundColor: {
            type: 'HexColor',
            order: 15,
          },
          discountBoxTextColor: {
            type: 'HexColor',
            order: 16,
          },
          discountBoxTextSize: {
            type: 'RangePx',
            data: {
              max: 15,
              min: 0,
              step: 1,
            },
            order: 17,
          },
          discountBoxTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 18,
          },
          discountText: {
            type: 'Text',
            order: 31,
          },
        },
      },
      Menu_IconSettings: {
        type: 'Menu',
        order: 400,
        renderOptions: {
          controlKey: 'iconSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isIcon',
            },
            options: {
              icon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 24,
              },
              iconColor: {
                type: 'HexColor',
                order: 26,
              },
              iconWidth: {
                order: 27,
                data: {
                  max: 32,
                  min: 12,
                  step: 1,
                },
                type: 'RangePx',
              },
            },
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'AddCart_1',
      name: 'AddCart_1',
      type: 'ProductDetailAddCart',
      data: {
        priceText: 'Toplam Tutar',
        buttonText: 'Sepete Ekle',
      },
      customization: {
        priceTextSize: '12px',
        priceTextColor: '#000000',
        priceTextWeight: '600',
        buttonTextSize: '12px',
        buttonTextColor: '#FFFFFF',
        buttonTextWeight: '600',
        buttonBackgroundColor: '#41a452',
        backgroundColor: '#ffffff',
        discountPriceNumberTextSize: '12px',
        discountPriceNumberTextColor: '#000000',
        discountPriceNumberTextWeight: '600',
        sellPriceNumberTextSize: '12px',
        sellPriceNumberTextColor: '#000000',
        sellPriceNumberTextWeight: '600',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/AddCart_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AddCart_2',
      name: 'AddCart_2',
      type: 'ProductDetailAddCart',
      data: {
        buttonText: 'Sepete Ekle',
      },
      customization: {
        buttonTextSize: '10px',
        buttonTextColor: '#FFFFFF',
        buttonTextWeight: '600',
        buttonBackgroundColor: '#F2791B',
        backgroundColor: '#ffffff',
        discountPriceNumberTextSize: '10px',
        discountPriceNumberTextColor: '#B70C01',
        discountPriceNumberTextWeight: '600',
        sellPriceNumberTextSize: '10px',
        sellPriceNumberTextColor: '#BFC0BF',
        sellPriceNumberTextWeight: '600',
        discountBoxBackgroundColor: '#B70C01',
        discountBoxTextColor: '#FFFFFF',
        discountBoxTextSize: '8px',
        discountBoxTextWeight: '400',
        discountBoxPadding: '4px 4px 4px 4px',
        discountBoxBorderRadius: '5px 5px 5px 5px',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/AddCart_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AddCart_3',
      name: 'AddCart_3',
      type: 'ProductDetailAddCart',
      data: {
        buttonText: 'Sepete Ekle',
      },
      customization: {
        buttonTextSize: '10px',
        buttonTextColor: '#FFFFFF',
        buttonTextWeight: '600',
        buttonBackgroundColor: '#F2791B',
        backgroundColor: '#ffffff',
        discountPriceNumberTextSize: '10px',
        discountPriceNumberTextColor: '#F2791B',
        discountPriceNumberTextWeight: '600',
        sellPriceNumberTextSize: '10px',
        sellPriceNumberTextColor: '#BFC0BF',
        sellPriceNumberTextWeight: '600',
        discountBoxBackgroundColor: '#F2791B',
        discountBoxTextColor: '#FFFFFF',
        discountBoxTextSize: '8px',
        discountBoxTextWeight: '400',
        discountBoxPadding: '4px 4px 4px 4px',
        discountBoxBorderRadius: '5px 5px 5px 5px',
        discountText: 'indirim',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/AddCart_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AddCart_4',
      name: 'AddCart_4',
      type: 'ProductDetailAddCart',
      data: {
        buttonText: 'Add',
      },
      customization: {
        buttonTextSize: '14px',
        buttonTextColor: '#FFFFFF',
        buttonTextWeight: '500',
        buttonBackgroundColor: '#027BBD',
        backgroundColor: '#FFFFFF',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/AddCart_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AddCart_5',
      name: 'AddCart_5',
      type: 'ProductDetailAddCart',
      data: {
        buttonText: 'Sepete Ekle',
      },
      customization: {
        buttonTextSize: '14px',
        buttonTextColor: '#FFFFFF',
        buttonTextWeight: '500',
        buttonBackgroundColor: '#014921',
        backgroundColor: '#FFFFFF',
        isIcon: true,
        icon: 'https://d9aff4nz0lkg0.cloudfront.net/mobligo/3bd48b49-bdf1-426b-897e-0d989a7c27e1/1748865902275.png',
        iconColor: '#FFFFFF',
        iconWidth: '20px',
        betweenProductAndBorderPadding: '0px 0px 0px 0px',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/AddCart_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AddCart_ProteinOcean',
      name: 'AddCart_ProteinOcean',
      type: 'ProductDetailAddCart',
      data: {
        buttonText: 'Sepete Ekle',
      },
      customization: {},
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/AddCart_ProteinOcean.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'AddCart_HicretKuruyemis',
      name: 'AddCart_HicretKuruyemis',
      type: 'ProductDetailAddCart',
      data: {
        buttonText: 'Sepete Ekle',
      },
      customization: {},
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/AddCart_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default ProductDetailAddCart;
